// One product, six years. Everything that changes between Year 1 and Year 6
// lives in this registry — the Home experience itself never forks.

export const STAGES = {
  1: "Explorer",
  2: "Discoverer",
  3: "Adventurer",
  4: "Pathfinder",
  5: "Trailblazer",
  6: "Pioneer",
};

export const YEAR_CONFIG = {
  1: {
    world: "Gentle Meadow",
    band: "early",
    fruit: ["1", "2", "3"],
    glyphs: ["A", "b", "c"],
    maths: ["Counting", "Numbers", "Addition", "Subtraction", "Comparing Numbers", "Shapes"],
    english: ["Letter Sounds", "Reading Words", "Story Time", "Listening", "Speaking", "Vocabulary"],
    experiences: {
      maths: [
        { id: "water", label: "Water the Plant", topic: "Counting", to: "/experiences/year1/water-the-plant" },
        { id: "addition", label: "Addition Story", topic: "Addition", to: "/experiences/year1/addition" },
      ],
      english: [],
    },
    adventures: [
      { icon: "Drop", title: "Water the Plant", goal: "Count to three helping a thirsty plant", subject: "Maths", to: "/experiences/year1/water-the-plant" },
      { icon: "Plus", title: "Addition Story", goal: "Add apples with a hungry bunny", subject: "Maths", to: "/experiences/year1/addition" },
    ],
    ground: { back: "#C5EBD6", mid: "#B2E3C8", front: "#96D9B4", front2: "#84D1A8", path: "#F6E7C4", edge: "#E8D3A4", tuft: "#5FBF8C" },
  },
  2: {
    world: "Bloom Village",
    band: "early",
    fruit: ["+", "\u2212", "10"],
    glyphs: ["c", "a", "t"],
    maths: ["Place Value", "Addition", "Subtraction", "Multiplication", "Division", "Money", "Time", "Measurement", "Fractions"],
    english: ["Reading", "Grammar", "Stories", "Vocabulary", "Writing", "Speaking"],
    experiences: { maths: [], english: [] },
    adventures: [
      { icon: "Basket", title: "Shopping Basket", goal: "Practise addition and money", subject: "Maths" },
      { icon: "Clock", title: "The Clock Shop", goal: "Learn to tell the time", subject: "Maths" },
      { icon: "Books", title: "Story Corner", goal: "Read a story and spot the characters", subject: "English" },
    ],
    ground: { back: "#C9ECCF", mid: "#B5E4BE", front: "#9CDCA8", front2: "#8AD497", path: "#F4E3BC", edge: "#E5CF9C", tuft: "#5FBF7E" },
  },
  3: {
    world: "Explorer Trail",
    band: "middle",
    fruit: ["\u00D7", "\u00F7", "12"],
    glyphs: ["!", "?", ","],
    maths: ["Place Value", "Multiplication", "Division", "Fractions", "Measurement", "Time", "Geometry", "Statistics"],
    english: ["Reading", "Comprehension", "Grammar", "Writing", "Spelling"],
    experiences: { maths: [], english: [] },
    adventures: [
      { icon: "ChartPieSlice", title: "Pizza Party", goal: "Share pizzas into equal fractions", subject: "Maths" },
      { icon: "GridFour", title: "Times Table Trek", goal: "Master the 3 and 4 times tables", subject: "Maths" },
      { icon: "MagnifyingGlass", title: "Story Detective", goal: "Find clues hidden in a story", subject: "English" },
    ],
    ground: { back: "#D3EAC6", mid: "#C0E2B0", front: "#A8D794", front2: "#96CF82", path: "#EFD9AC", edge: "#DFC48D", tuft: "#74B45F" },
  },
  4: {
    world: "Learning Woodland",
    band: "middle",
    fruit: ["\u00BD", "\u00BC", "\u00BE"],
    glyphs: ["\u201C", "A", "\u201D"],
    maths: ["Multiplication Tables", "Fractions", "Decimals", "Measurement", "Area", "Geometry", "Statistics"],
    english: ["Reading", "Grammar", "Writing", "Poetry", "Vocabulary"],
    experiences: { maths: [], english: [] },
    adventures: [
      { icon: "Ruler", title: "Playground Planner", goal: "Measure area and perimeter", subject: "Maths" },
      { icon: "Coins", title: "Decimal Diner", goal: "Add up prices with decimals", subject: "Maths" },
      { icon: "Quotes", title: "Poetry Grove", goal: "Write a poem about the woodland", subject: "English" },
    ],
    ground: { back: "#BFE3C4", mid: "#A3D8AC", front: "#83CB92", front2: "#6FC282", path: "#EBD3A6", edge: "#D9BE86", tuft: "#4FA96B" },
  },
  5: {
    world: "Bloom Town",
    band: "upper",
    fruit: ["0.5", "%", "1.2"],
    glyphs: ["\u2026", ";", "\u2014"],
    maths: ["Fractions", "Decimals", "Percentages", "Geometry", "Volume", "Algebra", "Graphs"],
    english: ["Reading Comprehension", "Creative Writing", "Grammar", "Inference", "Vocabulary", "Poetry"],
    experiences: { maths: [], english: [] },
    adventures: [
      { icon: "Percent", title: "Sale Day", goal: "Work out percentage discounts in town", subject: "Maths" },
      { icon: "Cube", title: "Aquarium Architect", goal: "Design tanks and calculate volume", subject: "Maths" },
      { icon: "PenNib", title: "Front Page News", goal: "Write a report for the Bloom Gazette", subject: "English" },
    ],
    ground: { back: "#C6E7D4", mid: "#AFDDC2", front: "#93D2AC", front2: "#7FC99C", path: "#E9E2D3", edge: "#D4CBB6", tuft: "#5FB98C" },
  },
  6: {
    world: "Bloom Academy",
    band: "upper",
    fruit: ["x", "y", "="],
    glyphs: ["\u2713", "!", "?"],
    maths: ["Algebra", "Ratio", "Fractions", "Percentages", "Geometry", "Statistics", "SATs Practice"],
    english: ["Reading Comprehension", "Grammar", "Writing", "Inference", "SATs Practice", "Creative Writing"],
    experiences: { maths: [], english: [] },
    adventures: [
      { icon: "Function", title: "Secret Codes", goal: "Crack hidden messages with algebra", subject: "Maths" },
      { icon: "Exam", title: "SATs Sprint", goal: "A calm, confident practice run", subject: "Maths" },
      { icon: "Detective", title: "Between the Lines", goal: "Infer what the author really means", subject: "English" },
    ],
    ground: { back: "#CDE6DA", mid: "#B7DCC9", front: "#9DD0B6", front2: "#88C7A7", path: "#E7E1D6", edge: "#D2C9BB", tuft: "#63AE8C" },
  },
};

export function getTodaysAdventure(year) {
  const list = YEAR_CONFIG[year].adventures;
  return list[new Date().getDate() % list.length];
}
